<template>
  <div id="app" v-title data-title="北京天蔚中医药发展促进中心">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      onLine: navigator.onLine,
    };
  },
  mounted() {
    if (window.location.pathname == "/") {
      if (this._isMobile()) {
        this.$router.replace("/mmain");
      } else {
        this.$router.replace("/");
      }
    }
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
      if (navigator.onLine) {
        location.reload();
      } else {
        //执行离线状态时的任务
        this.$message.warning("没网了哦");
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
};
</script>
<style lang="less" >
@media screen and (max-width: 900px) {
  .el-message--warning .el-message__content {
    font-size: 30px;
    line-height: 1.2;
  }
}
</style>
